export default {"src":"/_next/static/media/Logo-White.db24a701.svg","height":32,"width":114,"blurWidth":0,"blurHeight":0};